export default function percentService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    viewField.metadata.mask = 'number';
    viewField.metadata.icon = 'percent';
    const element = engineApi.field.generateNumber(viewField, engineApi);
    element.addAttribute('locale-format', 'number');

    return element;
  };
} // fin service
